import React from "react";
import { Heading } from "../../../design/heading";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../design/table";
import { useFile } from "../../../contexts/FileContext";
import CreateFileButton from "../../../components/CreateFileButton";
import FileStatusBadge from "../../../components/FileStatusBadge";
import EmptyStateView from "../../../components/EmptyStateView";
import { File } from "../../../models/File";
import moment from "moment";

interface Props {
  file: File;
}

const FileListItem: React.FC<Props> = ({ file }) => {
  return (
    <TableRow
      key={file._id}
      href={`/file/${file._id}`}
      className="transition-colors cursor-pointer hover:bg-gray-100"
    >
      <TableCell className="flex items-center gap-2">
        <div className="flex-col items-start">
          <span className="font-medium text-gray-800">{file.name}</span>
        </div>
      </TableCell>
      <TableCell>{file.size}</TableCell>
      <TableCell className="text-right">
        <span className="text-sm text-gray-500">
          {moment(file.updatedAt).format("MMMM D, YYYY")}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default FileListItem;
